import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Mail, Phone, MapPin, ArrowRight } from "lucide-react";
import logo from "../assets/images/logo_fk.png";

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavClick = (e, sectionId) => {
    e.preventDefault();

    // Si on est sur la page d'accueil
    if (location.pathname === "/") {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      // Si on est sur une autre page, naviguer vers l'accueil puis scroller
      navigate("/");
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  };

  return (
    <footer className="bg-black text-white py-16">
      <div className="container mx-auto px-4">
        {/* Main Footer Content */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <img
              src={logo}
              alt="FlowKraft Agency"
              className="h-20 w-auto mb-6"
            />
            <p className="text-gray-400 mb-6 leading-relaxed">
              Agence digitale spécialisée dans la création de solutions
              innovantes pour accompagner votre transformation numérique.
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.linkedin.com/company/flowkraft-agency/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 hover:bg-flowkraft-primary rounded-full flex items-center justify-center transition-all duration-300"
                aria-label="LinkedIn"
              >
                <svg
                  className="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                </svg>
              </a>
              <a
                href="https://www.instagram.com/flowkraft_agency?igsh=MWZmM2huZmd1azdydg=="
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 hover:bg-flowkraft-primary rounded-full flex items-center justify-center transition-all duration-300"
                aria-label="Instagram"
              >
                <svg
                  className="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
              </a>
              <a
                href="https://web.facebook.com/flowkraftagency"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 hover:bg-flowkraft-primary rounded-full flex items-center justify-center transition-all duration-300"
                aria-label="Facebook"
              >
                <svg
                  className="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
              </a>
              <a
                href="https://github.com/FlowKraft-Agency"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 hover:bg-flowkraft-primary rounded-full flex items-center justify-center transition-all duration-300"
                aria-label="GitHub"
              >
                <svg
                  className="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
                </svg>
              </a>
              <a
                href="https://www.codeur.com/-flowkraft"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 hover:bg-flowkraft-primary rounded-full flex items-center justify-center transition-all duration-300"
                aria-label="Codeur.com"
              >
                <svg
                  className="w-5 h-5"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 60 60"
                  fill="currentColor"
                >
                  <path d="M35 10c-10.5 0-19 4.7-23.7 12.1-5.6 8.9-3.3 21.3 5 28.4 8.3 7 19.2 7.7 27.6 2.8 3.2-1.8 4.7-3.5 4.5-6-0.1-1.2-0.6-2.1-1.6-3.1l-2.8-2.8c-2-2-4.8-1.1-5.7-0.5-2.9 1.9-6.5 2.3-9.7 1-5.8-2.1-8.9-9-5.6-15 3-5.3 10-7 15-3.8 2 1.3 4.4 1.1 6.1-0.5l2-2c0.4-0.4 0.8-0.8 1.2-1.2 2.2-2.3 1.5-5.3-1-6.9-3.8-2.4-8.5-3.7-12.8-3.7z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Services Column */}
          <div>
            <h4 className="font-bold text-lg mb-6 text-white">Nos Services</h4>
            <ul className="space-y-3 text-gray-400">
              <li>
                <Link
                  to="/services/developpement-web"
                  className="hover:text-flowkraft-secondary transition-colors inline-flex items-center group"
                >
                  <ArrowRight className="w-4 h-4 mr-2 opacity-0 group-hover:opacity-100 transition-opacity" />
                  Développement Web
                </Link>
              </li>
              <li>
                <Link
                  to="/services/developpement-mobile"
                  className="hover:text-flowkraft-secondary transition-colors inline-flex items-center group"
                >
                  <ArrowRight className="w-4 h-4 mr-2 opacity-0 group-hover:opacity-100 transition-opacity" />
                  Développement Mobile
                </Link>
              </li>
              <li>
                <Link
                  to="/services/design-ux-ui"
                  className="hover:text-flowkraft-secondary transition-colors inline-flex items-center group"
                >
                  <ArrowRight className="w-4 h-4 mr-2 opacity-0 group-hover:opacity-100 transition-opacity" />
                  Design UX/UI
                </Link>
              </li>
              <li>
                <Link
                  to="/services/marketing-digital"
                  className="hover:text-flowkraft-secondary transition-colors inline-flex items-center group"
                >
                  <ArrowRight className="w-4 h-4 mr-2 opacity-0 group-hover:opacity-100 transition-opacity" />
                  Marketing Digital
                </Link>
              </li>
              <li>
                <Link
                  to="/services/consulting"
                  className="hover:text-flowkraft-secondary transition-colors inline-flex items-center group"
                >
                  <ArrowRight className="w-4 h-4 mr-2 opacity-0 group-hover:opacity-100 transition-opacity" />
                  Consulting & Stratégie
                </Link>
              </li>
            </ul>
          </div>

          {/* Quick Links Column */}
          <div>
            <h4 className="font-bold text-lg mb-6 text-white">Liens Rapides</h4>
            <ul className="space-y-3 text-gray-400">
              <li>
                <a
                  href="#services"
                  onClick={(e) => handleNavClick(e, "services")}
                  className="hover:text-flowkraft-secondary transition-colors inline-flex items-center group cursor-pointer"
                >
                  <ArrowRight className="w-4 h-4 mr-2 opacity-0 group-hover:opacity-100 transition-opacity" />
                  Services
                </a>
              </li>
              <li>
                <a
                  href="#process"
                  onClick={(e) => handleNavClick(e, "process")}
                  className="hover:text-flowkraft-secondary transition-colors inline-flex items-center group cursor-pointer"
                >
                  <ArrowRight className="w-4 h-4 mr-2 opacity-0 group-hover:opacity-100 transition-opacity" />
                  Méthodologie
                </a>
              </li>
              <li>
                <Link
                  to="/portfolio"
                  className="hover:text-flowkraft-secondary transition-colors inline-flex items-center group cursor-pointer"
                >
                  <ArrowRight className="w-4 h-4 mr-2 opacity-0 group-hover:opacity-100 transition-opacity" />
                  Portfolio
                </Link>
              </li>
              <li>
                <a
                  href="#testimonials"
                  onClick={(e) => handleNavClick(e, "testimonials")}
                  className="hover:text-flowkraft-secondary transition-colors inline-flex items-center group cursor-pointer"
                >
                  <ArrowRight className="w-4 h-4 mr-2 opacity-0 group-hover:opacity-100 transition-opacity" />
                  Témoignages
                </a>
              </li>
              <li>
                <a
                  href="#contact"
                  onClick={(e) => handleNavClick(e, "contact")}
                  className="hover:text-flowkraft-secondary transition-colors inline-flex items-center group cursor-pointer"
                >
                  <ArrowRight className="w-4 h-4 mr-2 opacity-0 group-hover:opacity-100 transition-opacity" />
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h4 className="font-bold text-lg mb-6 text-white">
              Contactez-nous
            </h4>
            <ul className="space-y-4 text-gray-400">
              <li className="flex items-start">
                <MapPin className="w-5 h-5 text-flowkraft-secondary mr-3 mt-1 flex-shrink-0" />
                <span>France, Toulouse</span>
              </li>
              <li className="flex items-start">
                <Mail className="w-5 h-5 text-flowkraft-secondary mr-3 mt-1 flex-shrink-0" />
                <a
                  href="mailto:info@flowkraftagency.com"
                  className="hover:text-flowkraft-secondary transition-colors"
                >
                  info@flowkraftagency.com
                </a>
              </li>
              <li className="flex items-start">
                <Phone className="w-5 h-5 text-flowkraft-secondary mr-3 mt-1 flex-shrink-0" />
                <a
                  href="tel:+33652794562"
                  className="hover:text-flowkraft-secondary transition-colors"
                >
                  +33 (0)6 52 79 45 62
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              &copy; {new Date().getFullYear()} FlowKraft Agency. Tous droits
              réservés.
            </p>
            <div className="flex gap-6 text-sm text-gray-400">
              <a
                href="/mentions-legales"
                className="hover:text-flowkraft-secondary transition-colors"
              >
                Mentions légales
              </a>
              <a
                href="/politique-confidentialite"
                className="hover:text-flowkraft-secondary transition-colors"
              >
                Politique de confidentialité
              </a>
              <a
                href="/cgv"
                className="hover:text-flowkraft-secondary transition-colors"
              >
                CGV
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
